/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const apiValidationWorkflowsPartialUpdateBodyNameMax = 256;

export const apiValidationWorkflowsPartialUpdateBodyDescriptionMax = 1024;

export const ApiValidationWorkflowsPartialUpdateBody = zod.strictObject({
    name: zod
        .string()
        .min(1)
        .max(apiValidationWorkflowsPartialUpdateBodyNameMax)
        .optional(),
    description: zod
        .string()
        .max(apiValidationWorkflowsPartialUpdateBodyDescriptionMax)
        .optional(),
    forms: zod.array(zod.number()).optional(),
});

export type ApiValidationWorkflowsPartialUpdateBody = zod.input<
    typeof ApiValidationWorkflowsPartialUpdateBody
>;
export type ApiValidationWorkflowsPartialUpdateBodyOutput = zod.output<
    typeof ApiValidationWorkflowsPartialUpdateBody
>;
